import { LoadingOverlay, Stack, Stepper, Text } from "@mantine/core";
import { useEffect, useMemo, useState } from "react";
import { findProspect } from "../../../../../api/PRMAPI";
import { useLeadsContainerStore } from "../../../../../stores/LeadsStore";
import { parseProspectDatafields } from "../../utils";
import TabNotesItem from "../sheet/Right/notes/TabNotesItem";
import { useLanguage } from "../../../../../stores/LanguageStore";

const LeadHover = ({ current, container }) => {
  const lang = useLanguage((s) => s.language);
  const updateContainerItem = useLeadsContainerStore(
    (s) => s.updateContainerItem
  );
  const [loading, setLoading] = useState(false);

  const notes = useMemo(() => {
    return current?.history?.filter((x) => !!x.note) || [];
  }, [current.history]);

  useEffect(() => {
    setLoading(true);
    findProspect(current.id)
      .then((r) => {
        updateContainerItem(container.id, current.id, {
          ...parseProspectDatafields(r.data.contact_profile),
        });
      })
      .finally(() => setLoading(false));
  }, [container.id, current.id]);

  return (
    <Stack w={350} mih={50} pt={"md"}>
      <LoadingOverlay visible={loading} />

      {notes?.length > 0 ? (
        <Stepper
          active={0}
          iconSize={28}
          size="sm"
          radius={"lg"}
          styles={{ stepIcon: { border: "none", background: "none" } }}
          orientation="vertical"
        >
          {notes.map((item, index) => (
            <TabNotesItem
              key={item?.id || index}
              item={item}
              isLast={index === notes.length - 1}
              small
              isPreview
            />
          ))}
        </Stepper>
      ) : (
        <Text c={"dimmed"} ta={"center"} size="lg">
          {lang.prm.details.no_note}
        </Text>
      )}
    </Stack>
  );
};

export default LeadHover;
